import { ListMenu } from '@components';
import useWindowDimensions from '@hooks/useWindowSize';
import { SEOLayout } from '@layouts';
import { ServerSideProps } from '@utils/getServerSideProps';
import classNames from 'classnames';
import { FC, memo, useState } from 'react';
import features from '../../constants/features';
import { Competitors, ManagersWalletAndRewardsFeature } from './containers';
import styles from './styles.module.scss';

export const Features: FC<ServerSideProps> = memo(({ userAgent }) => {
  const { isDesktop } = useWindowDimensions(userAgent);
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <SEOLayout
      title="Features"
      description="Discover our diverse range of core features that empower your team and enhance workplace dynamics. Explore the Managers Wallet & Rewards, Rewards Marketplace, Appreciation Wall, Exchange Platform, Wellbeing Station, Recognition Voting Platform, Gamification, and Admin Controls & Customization. Elevate productivity and foster a thriving work environment with our thoughtfully designed features. Unleash the full potential of your team today!"
    >
      <div className={styles.container} id="core-features">
        <h1>Core Features</h1>
        <div className={styles.featureContainer}>
          <div className={styles.featureLinksContainer}>
            {isDesktop ? (
              features.map((feature, index) => (
                <button
                  type="button"
                  className={classNames(styles.button, {
                    [styles.modCurrent]: selectedIndex === index,
                  })}
                  onClick={() => setSelectedIndex(index)}
                >
                  {`${feature.emoji} ${feature.title}`}
                </button>
              ))
            ) : (
              <ListMenu
                listItems={features.map((feature) => ({
                  title: feature.title,
                  emoji: feature.emoji,
                }))}
                currentFeatureIndex={selectedIndex}
                onPress={setSelectedIndex}
              />
            )}
          </div>
          {/* TODO: Rename component */}
          <ManagersWalletAndRewardsFeature
            title={features[selectedIndex].title}
            bullets={features[selectedIndex].bullets}
            image={features[selectedIndex].image}
          />
        </div>
      </div>
      <div id="why-perksbar" className={styles.competitorsOuterContainer}>
        <div className={classNames(styles.competitorsContainer, styles.featureContainer)}>
          <div className={classNames(styles.competitors, styles.container)}>
            <Competitors />
          </div>
        </div>
      </div>
    </SEOLayout>
  );
});

Features.displayName = 'Features';

export default Features;
